import Component from "@glimmer/component";
import { task, Task } from "ember-concurrency";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { shape, instanceOf } from "prop-types";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";
import TaskForm from "glesys-controlpanel/components/task-form";
import PasswordReveal from "glesys-controlpanel/components/password-reveal";
import InstanceUser from "glesys-controlpanel/models/instance-user";

@forbidExtraArgs
export default class ModalsDatabaseResetUserPassword extends Component {
  @arg(
    shape({
      user: instanceOf(InstanceUser).isRequired,
      task: instanceOf(Task).isRequired,
    }).isRequired,
  )
  params;

  onSubmitTask = task(async () => {
    return await this.params.task.perform(this.params.user);
  });

  <template>
    {{#if this.onSubmitTask.lastSuccessful}}
      <Header>
        {{t "databases.details.users.reset.success-title" username=this.params.user.username}}
      </Header>
      <Body data-test-modal-database-reset-user-password-success>
        <PasswordReveal @password={{this.onSubmitTask.lastSuccessful.value.password}} />
      </Body>
      <Footer>
        <GButton data-test-modal-database-reset-user-password-done @color="blue" {{on "click" (modalClose)}}>
          {{t "databases.details.users.created.done"}}
        </GButton>
      </Footer>
    {{else}}
      <Header>{{t "databases.details.users.reset.title"}}</Header>
      <Body>
        <TaskForm id="reset-user-password-form" @task={{this.onSubmitTask}}>
          <p class="text-gray-700">
            {{t "databases.details.users.reset.description" username=this.params.user.username}}
          </p>
        </TaskForm>
      </Body>
      <Footer>
        <GButton class="mr-2" data-test-cancel-button @color="gray" {{on "click" (modalClose)}}>
          {{t "button.cancel"}}
        </GButton>
        <GButton
          data-test-modal-database-reset-user-password-submit
          @type="submit"
          @color="blue"
          @loading={{this.onSubmitTask.isRunning}}
          form="reset-user-password-form"
        >
          {{t "databases.details.users.reset.submit"}}
        </GButton>
      </Footer>
    {{/if}}
  </template>
}
